import { render, staticRenderFns } from "./AtenaPaperSelectCard.vue?vue&type=template&id=556f961e&scoped=true"
import script from "./AtenaPaperSelectCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./AtenaPaperSelectCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AtenaPaperSelectCard.vue?vue&type=style&index=0&id=556f961e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556f961e",
  null
  
)

export default component.exports